import { User } from 'containers/user/types/user'
import { useProfile } from './useProfile'
import { useMemo } from 'react'

export const useIsProfileFreebirdEligible = (profile?: User) => {
  const { profile: currentProfile } = useProfile()
  const profileUsing = profile || currentProfile

  return useMemo(
    () =>
      profileUsing?.creatorType?.includes('Brand Manager') ||
      profileUsing?.creatorType?.includes('Entrepreneur') ||
      profileUsing?.creatorType?.includes('Founder') ||
      profileUsing?.creatorType?.includes('Influencer Marketer') ||
      profileUsing?.creatorType?.includes('Marketing Professional') ||
      profileUsing?.creatorType?.includes('Talent Manager'),
    [profileUsing]
  )
}
